import { callActionChanges, callWindowTranscription, getVmTranscript, toastInformation } from "./common";
import store from "../../context/store/store";
import { Types } from "../../context/action/action";
import { closeCaptionmeetingState, currentCallDetail } from "../../models/callModel";
import { getCallHistoryByExt } from "./callsApiService";
import { generateChatID, userInfo } from "../socketChatService/utils";

export const update_Voice_Spec_Language = (lanChar: string) => {

  store.dispatch({
    type: Types.VOICE_SPEAKER_DEFAULT,
    payloads: lanChar
  });
};

export const update_Mic_Language = (lanChar: string) => {
  
  store.dispatch({
    type: Types.ASR_MIC_DEFAULT,
    payloads: lanChar
  });

};

export const update_Spec_Language = (lanChar: string) => {

  if (lanChar === 'en' || lanChar === 'es' || lanChar === 'fr') {
    store.dispatch({
      type: Types.ASR_SPEAKER_DEFAULT,
      payloads: lanChar
    });
  }
  else { toastInformation('Currently we are not supporting this language', "failure"); }

};


export const switchComponent = (selectedMode: string) => {
  let callStore: currentCallDetail = store.getState().updatedCallList || [];
  if(!callStore.isCallActive)
  {
    store.dispatch({
      type: Types.UPDATE_CALL_INFO,
      payloads: {
        centerWindow:(selectedMode === 'callList') ? 'callDetail' : (selectedMode === 'voiceMail') ? 'voiceDetail' : 'recordDetail',
        rightSideWindow: 'dialpad',
        isWindowSlide:  callStore.minimizedWindow?false:callStore.isWindowSlide,
        minimizedWindow:  callStore.minimizedWindow,
        isTranscriptionOnOff:true,
        callDetails:callStore.callDetails,
        isCallFullScreen:callStore.minimizedWindow?true:callStore.isCallFullScreen,
        isCallActive:callStore.isCallActive
      }
    });
  }
  else{
    store.dispatch({
      type: Types.UPDATE_CALL_INFO,
      payloads: {
        centerWindow:(selectedMode === 'callList') ? 'callDetail' : (selectedMode === 'voiceMail') ? 'voiceDetail' : 'recordDetail',
        rightSideWindow: 'dialpad',
        isWindowSlide: (callStore.callDetails.length === 0) ? callStore.isWindowSlide : false,
        minimizedWindow: (callStore.callDetails.length === 0) ? callStore.minimizedWindow : true,
        isTranscriptionOnOff:true,
        callDetails:callStore.callDetails,
        isCallFullScreen:false,
        isCallActive:callStore.isCallActive
      }
    });
  }

  store.dispatch({
    type: Types.CALL_LIST_TYPE,
    payloads: {
      leftSideWindow: selectedMode
    }
  });
  store.dispatch({ type: Types.CLEAR_CALL_PAGE });

};

export const automatedMintsStore = (component:string, sourcePath:string, shareFrom:string) => {
  store.dispatch({
    type: Types.ASR_CALLING_FROM,
    payload: { asrCallingFrom: sourcePath ,isTranscriptLoading:false}
  });
  
  store.dispatch({
    type: Types.SHARE_TEXT,
    payload: {
      shareFrom: shareFrom
    }
  });
  if (sourcePath === 'callList') { callWindowTranscription(component); }
  else { callActionChanges(component); }
};

export const storeDirectNumber = (directNumberList:any) => {
  store.dispatch({
    type: Types.GET_DIRECT_NUMBER,
    payloads: directNumberList
  });
};

export const storeCallHistory = (history:any) => {
  store.dispatch({
    type: Types.CALL_HISTORY,
    payloads: {
      callHistory: history
    }
  });
};


export const urlTranscription = (obj:any,captionTxt:any,time:any) => {
  store.dispatch({
    type: Types.VOICE_MAIL_CAPTION,
    payload: {
      voiceDataStore: {
        voiceCaption: obj,
        voiceCaptionText: captionTxt,
        voiceTimer:time
      }
    }
  });
};

export const storeUrlTranscript = (transcriptData:any) => {
  store.dispatch({
    type: Types.VOICE_MAIL_TRANSCRIPTS,
    payload: { transcripts: transcriptData }
  });

  let caption:closeCaptionmeetingState = store.getState().closeCaption || [];
  let data = store.getState().updatedCallList || [];


  if(data.isCallActive){
    store.dispatch({
      type: Types.UPDATDE_WINDOW_SLIDE,
      payloads: {
        isWindowSlide: data.isWindowSlide,
        isCallFullScreen: false,
        rightSideWindow: 'dialpad',
        isTranscriptionOnOff:false
      }
    });
  }
    
};

export const callPlusIconAction = (action:boolean,fromPath:string) => {
  store.dispatch({
    type: Types.CALL_PLUS_ICON,
    payloads: {
      callPlusIcon: action,
      callIconStatus: fromPath,
      minimizedWindow:action
    }
  });
}

export const popoutStores = () => {
  console.log('popoutStores')
  let updatedCallList: currentCallDetail = store.getState().updatedCallList || [];
  store.dispatch({
    type: Types.UPDATDE_WINDOW_SLIDE,
    payloads: {
      isWindowSlide:false,
      isCallFullScreen: !updatedCallList.isCallFullScreen,
      rightSideWindow: 'dialpad',
      isTranscriptionOnOff:true
    }
  });

  console.log('updatedCallList====>>>',updatedCallList)
}

export const expandArrowCalling = () => {
  store.dispatch({
    type: Types.TRANSCRIPT_MODE,
    payloads: {
      isTranscriptionOnOff:false
    }
  });
}

//Call phase 2 changes
export const storeLogs = (logs:any) => {
  store.dispatch({
    type: Types.CALL_LOGS_BAR,
    payloads: {
      logs: logs
    }
  });
}
export const modifyLogsInput = (search: string, offset: number, filter?: string) => {
  
  let { logsInput } = store.getState().callReducer || {};
  let inputData = {
    'offset': offset,
    'search': search,
    'filter':filter?filter:logsInput.filter
  };



  store.dispatch({
    type: Types.MODIFY_CALL_LOGS,
    payloads: {
      isLogLoading: true,
      logsInput: inputData
    }
  }); 
}

export const storeParticularLog = (detail: any,isload:boolean) => {
  let { leftSideWindow,rightSideWindow } = store.getState().updatedCallList;
  let { callHistory } = store.getState().callReducer || {};
  store.dispatch({
    type: Types.CALL_DETAIL_PAGE,
    payloads: {
      particularLog: detail,
      isParticularLoading:isload
    }
  });
  if (leftSideWindow === 'callList' && callHistory.length === 0) { getCallHistoryByExt(1); }

  if (leftSideWindow === 'voiceMail' || leftSideWindow==='recordList') {
    if(leftSideWindow === 'voiceMail'){getVmTranscript(detail?.Vm_uuid)}
    storeUrlTranscript([]);}

}

export const storeCallType = (type: string) => {
  store.dispatch({
    type: Types.CALL_TYPE,
    payloads: {
      callType:type
    }
  })

  };

export const storeChatWindow=(obj:any)=>{

  let switchVal:boolean=false;
  let {isProfileView,rightSideWindow}=store.getState().updatedCallList||{};
  let {particularLog}=store.getState().callReducer||{};

   if(rightSideWindow!=='dialpad'){
    switchVal=true;
    store.dispatch({
      type: Types.UPDATE_RIGHT_WINDOOW,
      payloads: {
        rightSideWindow:'dialpad'
      }
    }); 
   }
   else{
    switchVal=( particularLog!==obj)?true:!isProfileView
   }
  store.dispatch({
    type: Types.OPEN_PROFILE_VIEW,
    payloads: {
        isProfileView:switchVal
    }
  }); 
   if(obj){
  let chatId: any = generateChatID(userInfo().fromID, obj?.sip_login_id?.toString()) 
    obj.chatId=chatId;
   }
  store.dispatch({
    type: Types.SET_CONTACT_WINDOW,
    payload: {
        chatWindowDetails: obj
    }
});

}

export const closePrfWindow=()=>{
  
  store.dispatch({
    type: Types.OPEN_PROFILE_VIEW,
    payloads: {
        isProfileView:false
    }
  }); 
  // store.dispatch({
  //   type: Types.SET_CONTACT_WINDOW,
  //   payload: {
  //       chatWindowDetails: {}
  //   }
  // }); 

}
export const storeUndoStep=(step:number)=>{
  store.dispatch({
    type: Types.UNDO_STEP,
    payloads: {
      undoStep: step
    }
  });
}

export const setAddCall=(isAdd:boolean)=>{
  store.dispatch({
    type: Types.ADD_CALL,
    payloads: {
        isAddCall: isAdd
    }
});
}

export const storeActiveLogs = (logs:any) => {
  store.dispatch({
    type: Types.SET_ACTIVE_LOGS,
    payloads: {
      activeLogs: logs
    }
  });
}

export const storeHoldTeam = (isHold:boolean,callType:string,internalUsers:any,externalUser?:any) => {
store.dispatch({
  type: Types.TEAM_CALL_HOLD,
  payloads: {
    isTeamCallHold :isHold,
    callType:callType,
    internalUsers : internalUsers,
    externalUsers:externalUser
  }
})
}